export const findThemeLabel = (section, value) => {
	let label = value;
	section.map((s) => {
		if (s.value === value) label = s.label;
	});
	return label;
};
